import { FC } from 'react';

interface Props {
  position: { top: string | null; right: string | null; left: string | null };
  stroke: boolean;
  className?: string;
}

const EphemeralMessageStrokeTopRight: FC<Props> = ({ position, stroke, className = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="38"
      viewBox="0 0 31 38"
      fill="none"
      className={className}
      style={{
        position: 'absolute',
        top: `${position?.top}`,
        right: `${position?.right ? position?.right : ''}`,
        left: `${position?.left ? position?.left : ''}`,
        zIndex: '6',
      }}
    >
      {stroke && (
        <>
          <path
            d="M30.332 2C31.9257 2.00002 33.021 3.88049 32.1025 5.34473C29.8668 8.9087 27.1248 13.5348 24.9355 18.0332C23.841 20.2822 22.8691 22.5314 22.167 24.6211C21.7198 25.9521 21.3652 27.2715 21.1689 28.5186C21.1384 28.5185 21.1078 28.5187 21.0771 28.5186C21.2643 16.9583 16.8749 10.2592 12.043 6.48633C9.5348 4.52793 6.98366 3.41628 5.0625 2.79297C4.48151 2.60447 3.95436 2.46227 3.5 2.35156L3.5 2L30.332 2Z"
            fill="#FEFBF9"
            stroke="#F1F0EE"
            strokeWidth="4"
          />
          <path d="M1.31228e-06 26.5L3.28772e-07 4L30 4L18 27L1.31228e-06 26.5Z" fill="#FEFBF9" />
        </>
      )}
    </svg>
  );
};

export default EphemeralMessageStrokeTopRight;
